import { useState } from 'react';
import moment from 'moment';

import PromoCard from '../components/AllPromotions/PromoCard';
import SC from '../components/AllPromotions/promoElements';
import BreadCrumbs from '../components/BreadCrumbs';
import CardGrid from '../components/Cards/CardGrid';
import EmptyMessage from '../components/FilterCategories/EmptyMessage';
import FilterCategories from '../components/FilterCategories/FilterCategories';
import useFilterCategoriesHook from '../components/FilterCategories/useFilterCategoriesHook';
import SeoHead from '../components/SeoHead';
import { getPromotions } from '../services/api';
import withErrorHandling from '../utils/withErrorHandling';

import ErrorPage from './_error';

export const CardSection = ({ promoList }) => {
  return (
    <CardGrid>
      {promoList.map((promo) => {
        const { slug, id, name, partner, imgUrls, isEnding, isNew, startDate, endDate } = {
          ...promo,
        };
        const { landscapeBanner, banner } = imgUrls;
        return (
          <SC.PromoCardWrapper key={id}>
            <PromoCard
              permalink={slug}
              id={id}
              key={id}
              name={name}
              partner={partner.name}
              banner={landscapeBanner ? landscapeBanner : banner}
              isEnding={isEnding}
              isNew={isNew}
              startDate={startDate}
              endDate={endDate}
            />
          </SC.PromoCardWrapper>
        );
      })}
    </CardGrid>
  );
};

const AllPromotions = ({ categories, promoList, error }) => {
  const routes = {
    curr: { name: 'Discover Promotions' },
  };
  const [state, dispatch] = useFilterCategoriesHook();
  const { start, end, active, open, filterId } = state;
  const initialLoadValue = 20;
  const [endValue, setEndValue] = useState(initialLoadValue);
  let filteredData = promoList;
  if (filterId) {
    filteredData = promoList?.filter((promo) => promo.categoryIds.includes(Number(filterId)));
  }

  const handleClick = () => {
    setEndValue(endValue + initialLoadValue);
  };

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <SC.Contain data-testid="promotions-page">
      <SeoHead
        title="Discover All Promotions | Link Rewards"
        description="Plus! is now Link. Enjoy savings with the best deals on groceries, dining, shopping and more to get the best out of your life."
      />

      <BreadCrumbs routes={routes} />

      <FilterCategories
        filterCategories={categories}
        active={active}
        open={open}
        dispatch={dispatch}
        type="mobile"
      />
      <FilterCategories
        filterCategories={categories}
        start={start}
        end={end}
        active={active}
        open={open}
        dispatch={dispatch}
        type="desktop"
      />

      {filteredData?.length > 0 ? (
        <CardSection promoList={filteredData.slice(0, endValue)} />
      ) : (
        <EmptyMessage type="promotions" />
      )}

      {filteredData.length > endValue && <SC.LoadMore onClick={handleClick}>Load more</SC.LoadMore>}
    </SC.Contain>
  );
};

export const sortData = (allPromo) => {
  const currentDay = moment();
  const weekBefore = moment().subtract(7, 'd');
  const weekAfter = moment().add(7, 'd');
  return allPromo.map((promo) => {
    const createdDate = moment(promo.createdAt);
    const endDate = moment(promo.endDate);
    if (createdDate.isBetween(weekBefore, currentDay)) {
      return { ...promo, isNew: true };
    } else if (endDate.isBetween(currentDay, weekAfter)) {
      return !promo.isNew ? { ...promo, isEnding: true } : promo;
    }
    return promo;
  });
};

export const fetchPromoData = async () => {
  const res = await getPromotions();
  const categories = res.filters.categories;
  const promoData = res.list.map((obj) => ({
    ...obj,
    isEnding: false,
    isNew: false,
  }));

  const promoList = sortData(promoData);

  return {
    props: {
      categories,
      promoList,
    },
  };
};

export const getServerSideProps = withErrorHandling(fetchPromoData);

export default AllPromotions;
